export default __webpack_public_path__ + "static/media/orderHistory.9b9077d6.svg";